import { render, staticRenderFns } from "./Combobox.vue?vue&type=template&id=c454b294"
import script from "./Combobox.vue?vue&type=script&lang=js"
export * from "./Combobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports